import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  href?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const classes = `
    bg-brand-gold hover:bg-brand-gold-light text-brand-dark 
    font-bold py-4 px-8 rounded-sm shadow-lg
    transition-colors duration-300 uppercase tracking-wider text-sm md:text-base
    inline-block text-center
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-13">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-14">
      {children}
    </motion.button>;
}